var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoWhite = function SvgInfoWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    stroke: "#757575"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#757575",
    d: "M7.947 4.522q-.074.178-.074.387 0 .207.072.384t.216.325a1 1 0 0 0 .32.22 1 1 0 0 0 .383.074q.202 0 .375-.074a1 1 0 0 0 .317-.223q.144-.148.217-.325a1 1 0 0 0 .072-.38q0-.21-.073-.388a1 1 0 0 0-.216-.323.954.954 0 0 0-.692-.293.96.96 0 0 0-.696.293 1 1 0 0 0-.22.323M8.309 10.716v-.003L9.54 6.65l.003-.014a.045.045 0 0 0-.047-.043l-2.903.09a.044.044 0 0 0-.044.034L6.4 7.26l-.003.016c0 .024.02.045.045.045h.569c.279 0 .392.165.36.422-.019.153-.071.317-.113.466l-.65 1.97c-.13.412-.263.892-.1 1.314.26.669 1.164.705 1.737.483q.309-.12.603-.359l.003-.001a3.8 3.8 0 0 0 .58-.6q.285-.36.562-.844a.045.045 0 0 0-.011-.06l-.403-.3a.045.045 0 0 0-.061.016 9 9 0 0 1-.342.532q-.164.233-.315.404a1.7 1.7 0 0 1-.265.252q-.106.079-.178.079c-.214 0-.145-.25-.108-.38"
  })));
};
export default SvgInfoWhite;